// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1a9xe","field":"styles_field__5qJTV","fieldCol":"styles_fieldCol__1bFxu","diffCol":"styles_diffCol__2YoME","diff":"styles_diff__3CpVE"};